/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_MissingInputs */

const en_vc_status_missing = /** @type {(inputs: Vc_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still missing`)
};

const zh_vc_status_missing = /** @type {(inputs: Vc_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂时还没有`)
};

/**
* | output |
* | --- |
* | "Still missing" |
*
* @param {Vc_Status_MissingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_missing = /** @type {((inputs?: Vc_Status_MissingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_MissingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_missing(inputs)
	return zh_vc_status_missing(inputs)
});
export { vc_status_missing as "vc.status.missing" }